// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__WyhyA","buttons":"SendReceipts_buttons__10HCm","email":"SendReceipts_email__1yNpA","bookApptTitle":"SendReceipts_bookApptTitle__3Fc9z"};